import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type NavGuard = (() => void) | null;

interface NavGuardContextValue {
  guard: NavGuard;
  registerGuard: (guard: NavGuard) => void;
}

const NavGuardContext = createContext<NavGuardContextValue | undefined>(undefined);

export const NavGuardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [guard, setGuard] = useState<NavGuard>(null);

  const registerGuard = useCallback((next: NavGuard) => {
    setGuard(() => next);
  }, []);

  const value = useMemo(() => ({ guard, registerGuard }), [guard, registerGuard]);

  return <NavGuardContext.Provider value={value}>{children}</NavGuardContext.Provider>;
};

export function useNavGuard(): NavGuardContextValue {
  const ctx = useContext(NavGuardContext);
  if (!ctx) {
    throw new Error('useNavGuard must be used within a NavGuardProvider');
  }
  return ctx;
}
